<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      API token ophalen
    </div>
    <div class="p-2">
      <button @click="getToken()" class="btn btn-blue">
        API token ophalen
      </button>
      <p class="text-red-600 ml-4 mb-2 mt-0" v-if="apikey">
        Uw nieuwe API token is: {{ apikey }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "APItokenCard",
  data() {
    return {
      apikey: null
    };
  },
  methods: {
    getToken: async function() {
      let key = await this.$store.dispatch("refreshAPIKey");
      this.apikey = key.api_key;
    }
  }
};
</script>
